<template>
    <div class="yeMast">
        <div class="filter-card">
            <div class="filter-cell" @click="openPicker('engineering')">
                <span class="filter-label">工程</span>
                <span class="filter-value" :class="{ placeholder: !engineeringId }">{{ engineeringLabel }}</span>
                <i class="filter-arrow"></i>
            </div>
            <div class="filter-cell" @click="openPicker('section')">
                <span class="filter-label">标段</span>
                <span class="filter-value" :class="{ placeholder: !sectionId }">{{ sectionLabel }}</span>
                <i class="filter-arrow"></i>
            </div>
            <div class="filter-cell" @click="openPicker('device')">
                <span class="filter-label">设备</span>
                <span class="filter-value" :class="{ placeholder: !videoName }">{{ deviceLabel }}</span>
                <i class="filter-arrow"></i>
            </div>
        </div>

        <div
            class="picker-mask"
            v-show="pickerVisible"
            @click="closePicker"
            @touchmove.prevent
        ></div>
        <div
            class="picker-sheet"
            :class="{ show: pickerVisible }"
            @touchmove.stop
        >
            <div class="picker-header">
                <span class="picker-cancel" @click="closePicker">取消</span>
                <span class="picker-title">{{ pickerTitle }}</span>
                <span class="picker-placeholder"></span>
            </div>
            <div class="picker-search" v-if="pickerType !== 'quality'" @touchstart.stop @click.stop>
                <el-input
                    ref="pickerSearchInput"
                    class="picker-search-input"
                    v-model="pickerKeyword"
                    clearable
                    :placeholder="pickerSearchPlaceholder"
                    @input="onPickerSearchInput"
                    @compositionstart.native="pickerComposing = true"
                    @compositionend.native="onPickerSearchCompositionEnd"
                    @click.native.stop="focusPickerSearch"
                    @touchstart.native.stop="focusPickerSearch"
                />
            </div>
            <div
                class="picker-body"
                @touchmove.stop
            >
                <template v-if="pickerType === 'engineering'">
                    <div class="picker-option" v-for="item in filteredEngineerList" :key="'eng_' + item.id"
                        :class="{ active: item.id === engineeringId }" @click="selectEngineering(item.id)">
                        <span class="picker-option-text">{{ item.engineeringName }}</span>
                        <i class="picker-check" v-if="item.id === engineeringId"></i>
                    </div>
                    <div class="picker-empty" v-if="!filteredEngineerList.length">暂无匹配工程</div>
                </template>
                <template v-else-if="pickerType === 'section'">
                    <div class="picker-option" v-for="item in filteredSectionList" :key="'sec_' + item.id"
                        :class="{ active: item.id === sectionId }" @click="selectSection(item.id)">
                        <span class="picker-option-text">{{ item.sectionName }}</span>
                        <i class="picker-check" v-if="item.id === sectionId"></i>
                    </div>
                    <div class="picker-empty" v-if="!filteredSectionList.length">暂无匹配标段</div>
                </template>
                <template v-else-if="pickerType === 'device'">
                    <div v-for="itemChild in filteredSideList" :key="'group_' + itemChild.groupIndex">
                        <div class="picker-group" v-if="itemChild.place">{{ itemChild.place }}</div>
                        <div class="picker-option" v-for="child in itemChild.channelList"
                            :key="itemChild.groupIndex + '_' + child.childIndex + '_' + child.channelNo" :class="{
                                active: videoName === (itemChild.groupIndex + '~' + child.childIndex + '~' + child.serialNumber + '~' + child.channelNo)
                            }"
                            @click="selectDevice(itemChild.groupIndex + '~' + child.childIndex + '~' + child.serialNumber + '~' + child.channelNo)">
                            <span class="picker-option-text">{{ child.channelName }}</span>
                            <i class="picker-check"
                                v-if="videoName === (itemChild.groupIndex + '~' + child.childIndex + '~' + child.serialNumber + '~' + child.channelNo)"></i>
                        </div>
                    </div>
                    <div class="picker-empty" v-if="!filteredSideList.length">暂无匹配设备</div>
                </template>
                <template v-else-if="pickerType === 'quality'">
                    <div class="picker-option" v-for="(item, key) in qualityOptions" :key="'quality_' + key"
                        :class="{ active: item.id === quality }" @click="selectQuality(item.id)">
                        <span class="picker-option-text">{{ item.name }}</span>
                        <i class="picker-check" v-if="item.id === quality"></i>
                    </div>
                </template>
            </div>
        </div>

        <div
            class="picker-mask"
            v-show="playbackPickerVisible"
            @click="closePlaybackPicker"
            @touchmove.prevent
        ></div>
        <div
            class="picker-sheet playback-range-sheet"
            :class="{ show: playbackPickerVisible }"
            @touchmove.stop
        >
            <div class="picker-header">
                <span class="picker-cancel" @click="closePlaybackPicker">取消</span>
                <span class="picker-title">选择回放时间</span>
                <span class="picker-confirm" @click="confirmPlaybackRange">确定</span>
            </div>
            <div class="playback-range-body">
                <div class="playback-time-field">
                    <span class="playback-time-label">开始时间</span>
                    <el-date-picker
                        v-model="playbackStart"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择开始时间"
                        :editable="false"
                        :clearable="false"
                        popper-class="playback-datetime-popper"
                        class="playback-datetime-input"
                    />
                </div>
                <div class="playback-time-field">
                    <span class="playback-time-label">结束时间</span>
                    <el-date-picker
                        v-model="playbackEnd"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择结束时间"
                        :editable="false"
                        :clearable="false"
                        popper-class="playback-datetime-popper"
                        class="playback-datetime-input"
                    />
                </div>
            </div>
        </div>

        <div class="content">
            <div class="name">
                <div>
                    <i class="grey" :class="videoData.status == '1' ? 'green' : ''"></i>{{ videoData.place ?
                        videoData.place : videoData.name }}
                </div>
                <div class="quality-cell" @click="openPicker('quality')">
                    <span class="quality-text">{{ qualityLabel }}</span>
                    <i class="filter-arrow"></i>
                </div>
            </div>
            <div class="video">
                <template v-if="videoData && videoData.status">
                    <div class="video-container" id="video-container"></div>
                    <div class="video-loading" v-if="isVideoLoading">
                        <div class="load-spinner"></div>
                        <div class="load-text">加载中...</div>
                    </div>
                    <!-- <div class="video-toolbar" v-if="hasUrl && !isVideoLoading" @click.stop>
                        <div class="play-toggle" :class="playFlag ? 'is-playing' : 'is-paused'" @click="togglePlayPause"></div>
                    </div> -->
                </template>
                <template v-else>
                    <div class="offLine">设备离线</div>
                </template>
            </div>
        </div>

        <div class="bgcBox">
            <div class="bgc">
                <div class="top" @touchstart="controlDirection(0)" @touchend="stopDirection"></div>
                <div class="right" @touchstart="controlDirection(3)" @touchend="stopDirection"></div>
                <div class="bottom" @touchstart="controlDirection(1)" @touchend="stopDirection"></div>
                <div class="left" @touchstart="controlDirection(2)" @touchend="stopDirection"></div>
                <div class="center" @click="getcontrolEnd"></div>
            </div>
        </div>
        <a class="bottomtext" target="_blank" rel="noopener noreferrer"
            href="https://beian.miit.gov.cn">备案号:苏ICP备11019701号</a>

    </div>
</template>
<script>
import mix from "./yeMast_index";
// import EasyPlayer from "@easydarwin/easyplayer";
import LivePlayer from "@liveqing/liveplayer";
export default {
    mixins: [mix],
    components: {
        // EasyPlayer,
        LivePlayer
    }
};
</script>
<style lang="less" scoped>
@import "./yeMast.less";
</style>
<!-- 日期面板挂到 body，需全局样式放大触控区域 -->
<style lang="less">
.playback-datetime-popper {
    width: 92vw !important;
    max-width: 720px;

    .el-picker-panel__body-wrapper,
    .el-picker-panel__content {
        width: 100%;
    }

    .el-date-picker__header-label,
    .el-picker-panel__icon-btn {
        font-size: 18px;
    }

    .el-date-table th {
        font-size: 15px;
        padding: 12px 0;
    }

    .el-date-table td {
        padding: 6px 0;
    }

    .el-date-table td span {
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    .el-time-panel {
        width: 100%;
        max-width: none;
    }

    .el-time-spinner__item {
        height: 44px;
        line-height: 44px;
        font-size: 18px;
    }

    .el-time-panel__btn {
        font-size: 16px;
        padding: 10px 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/yeMast/yeMast.vue